import {get, post} from '../index'
export default {
  // 小程序颜色设置提交
  getapplet_color (querys) {
    return post('/admin/admin/config/applet_color', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/color.js